export default "__VITE_ASSET__DzapbtP7__"